import React from 'react';
import { MessageCircleIcon, YoutubeIcon, FacebookIcon, InstagramIcon } from 'lucide-react';
const GOLD = '#C9A24B';
const WHATSAPP_MESSAGE = encodeURIComponent('Bună ziua.\n\nSunt interesat de implementarea ProVi System.\n\nMulțumesc.');
export function Footer() {
  const legalLinks = [{
    label: 'TERMENI ȘI CONDIȚII',
    href: 'https://provisystem.ro/termeni-si-conditii'
  }, {
    label: 'POLITICA DE CONFIDENȚIALITATE',
    href: 'https://provisystem.ro/politica-de-confidentialitate'
  }, {
    label: 'POLITICA DE COOKIES',
    href: 'https://provisystem.ro/politica-cookies'
  }, {
    label: 'ANPC',
    href: 'https://anpc.ro/'
  }];
  const socials = [{
    label: 'WhatsApp',
    href: `https://wa.me/40745180514?text=${WHATSAPP_MESSAGE}`,
    Icon: MessageCircleIcon
  }, {
    label: 'Youtube',
    href: 'https://www.youtube.com/@valerdurabusinessexecutive2378',
    Icon: YoutubeIcon
  }, {
    label: 'Facebook',
    href: 'https://www.facebook.com/valer.dura',
    Icon: FacebookIcon
  }, {
    label: 'Instagram',
    href: 'https://www.instagram.com/valerdurabusinesscoach/',
    Icon: InstagramIcon
  }];
  return <footer className="w-full bg-[#09111F] pt-16 pb-8 border-t border-[rgba(255,255,255,0.08)]" data-id="element-42" data-mp="3gc0glhvmjq6k">
      <div className="max-w-[1280px] mx-auto px-6 md:px-12" data-id="element-43" data-mp="3v9az3b6opwbs">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 mb-12" data-id="element-44" data-mp="3q83pr7ow8p30">
          {/* CONTACT */}
          <div data-id="element-45" data-mp="81pfpjtqwz9w">
            <p className="font-['Montserrat'] text-[15px] font-bold tracking-[0.06em] mb-6" style={{
            color: GOLD
          }} data-id="element-46" data-mp="817b9zwxjeqw">
              CONTACT
            </p>
            <div className="space-y-4 font-['Inter'] text-[15px] text-[rgba(255,255,255,0.85)] leading-relaxed" data-id="element-47" data-mp="hrs9vnclsj9t">
              <p data-id="element-48" data-mp="cu8uul8302gt">PERFORMANCE COACHING & TRAINING SRL, CUI: 43061087</p>
              <p data-id="element-49" data-mp="qsqf28ys2wtz">Adresa: Satu Mare, strada Dragoș Vodă nr.10</p>
              <p data-id="element-50" data-mp="mrwp7a1rz7yg">Telefon: +40745180514</p>
              <p data-id="element-51" data-mp="msy27k2cq4it">
                email:{' '}
                <a href="mailto:valerdura@yahoo.com" className="hover:text-white transition-colors" data-id="element-52" data-mp="mq3g7o3owbna">
                  valerdura@yahoo.com
                </a>
              </p>
            </div>
          </div>

          {/* LEGAL */}
          <div data-id="element-53" data-mp="13sr2coqjivoz">
            <p className="font-['Montserrat'] text-[15px] font-bold tracking-[0.06em] mb-6" style={{
            color: GOLD
          }} data-id="element-54" data-mp="13s9ae4awv3mv">
              LEGAL
            </p>
            <div className="space-y-4" data-id="element-55" data-mp="1clum1ers44s2">
              {legalLinks.map(({
              label,
              href
            }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="block font-['Inter'] text-[15px] text-[rgba(255,255,255,0.85)] hover:text-white transition-colors" data-id="element-56" data-mp="1hjw4pylam230">
                  {label}
                </a>)}
            </div>
          </div>

          {/* SOCIAL MEDIA */}
          <div data-id="element-57" data-mp="3oc6qmwwjaxyz">
            <p className="font-['Montserrat'] text-[15px] font-bold tracking-[0.06em] mb-6" style={{
            color: GOLD
          }} data-id="element-58" data-mp="3ocpy1jok63yr">
              SOCIAL MEDIA
            </p>
            <div className="space-y-4" data-id="element-59" data-mp="2ag5dkmdud4ej">
              {socials.map(({
              label,
              href,
              Icon
            }) => <a key={label} href={href} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 font-['Inter'] text-[15px] text-[rgba(255,255,255,0.85)] hover:text-white transition-colors" data-id="element-60" data-mp="25mam2wrzvl4w">
                  <Icon className="w-5 h-5 flex-shrink-0" data-id="element-61" data-mp="1wlw2q2ylcg41" />
                  {label}
                </a>)}
            </div>
          </div>

          {/* ANPC + SOL Logos */}
          <div className="flex flex-col gap-4" data-id="element-62" data-mp="2pd5wc0e21p0v">
            <a href="https://anpc.ro/ce-este-sal/" target="_blank" rel="noopener noreferrer" className="bg-white rounded-lg p-2 hover:opacity-90 transition-opacity" data-id="element-63" data-mp="2kcrytca2xxh3">
              <img src="https://cdn.magicpatterns.com/uploads/qEkMe7B8gpamVaXefnKexi/ANPC.webp" alt="ANPC - Soluționarea Alternativă a Litigiilor" className="w-full h-auto" data-id="element-64" data-mp="2fgkrbf21cdx1" />
            </a>
            <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="bg-white rounded-lg p-2 hover:opacity-90 transition-opacity" data-id="element-65" data-mp="1414i0hsqao8h">
              <img src="https://cdn.magicpatterns.com/uploads/dUe8iPkBxBZ1Ryan5hWypX/Solutionarea_Online_a_Litigiilor.jpg" alt="Soluționarea Online a Litigiilor" className="w-full h-auto" data-id="element-66" data-mp="2wn98c31bap0b" />
            </a>
          </div>
        </div>

        {/* Divider + Copyright */}
        <div className="border-t border-[rgba(255,255,255,0.12)] pt-8 text-center" data-id="element-67" data-mp="3bj73bhzi1nay">
          <p className="font-['Inter'] text-[14px] text-[rgba(255,255,255,0.7)]" data-id="element-68" data-mp="3fl21idm4vkki">
            © Copyright 2026.{' '}
            <span className="font-bold text-white" data-id="element-69" data-mp="31mc38unkveuk">
              PERFORMANCE COACHING & TRAINING SRL
            </span>
            . Toate drepturile rezervate.
          </p>
        </div>
      </div>
    </footer>;
}